// extracted by mini-css-extract-plugin
export default {"promo":"dlGc9mHo","mobile":"mobile","desktop":"desktop","text":"nciQnZvn"};